import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { mediaMinDesktop } from '@root/shared/ui-kit'

import { TradingPairExploreItemMetricsPercent } from './pair-explore-item-metrics-percent'
import { TradingPairExploreItemMetricsSummary } from './pair-explore-item-metrics-summary'

import type { PairMetrics, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  showVolume?: boolean
  statsPeriod: PairMetrics.MetricsSpan
} & ClassNameProps

export const PairExploreItemMetrics: React.FC<Props> = ({
  pair,
  className,
  showVolume = true,
  statsPeriod,
}) => {
  const [priceChange] = useAtom(pair.stats[statsPeriod].priceChange)

  return (
    <Root className={className}>
      {showVolume && (
        <TradingPairExploreItemMetricsSummary
          pair={pair}
          statsPeriod={statsPeriod}
          withTrailingSeparator={!priceChange.isZero()}
        />
      )}
      <TradingPairExploreItemMetricsPercent
        pair={pair}
        priceChangePeriod={statsPeriod}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  justify-content: space-between;
  justify-items: start;

  gap: 8px;
  width: 100%;
  overflow: hidden;

  ${mediaMinDesktop(css`
    grid-template-columns: auto auto auto;
    justify-content: start;
  `)}
`
